export default API => ({
    // 积分商城商品分类
    goodsCategoryTree(params) {
        return API({
            url: `/order/v1/admin/goodsCategory/getTree`,
            method: 'get',
            params
        })
    },
    // 积分商城商品列表
    getGoodsList({params,data}){
        return API({
            url:`/order/v1/admin/integralGoods/list`,
            method:'post',
            params,
            data
        })
    },
    // 查询学员可用积分
    getUsablePoints(params) {
        return API({
            url: `/saas/v1/yxt/jf/getYxtIntegralInfoCount`,
            method: 'get',
            params
        })
    },
    // 积分商品详情
    getIntegralEditInfo({params}) {
        return API({
            url: `/order/v1/admin/integralGoods/editInfo`,
            method: 'get',
            params
        })
    },
    // 积分商品确认兑换
    junpeiBuy(data) {
        return API({
            url: `/saas/v1/junpei/jf/buy`,
            method: 'post',
            data
        })
    },
    getRegionList() {
        return API({
            url: '/usercenter/v1/region/getTree'
        });
    },
    // 积分商品确认订单
    selectEntityGoods(data) {
        return API({
            url: `/order/v1/admin/integralGoods/selectEntityGoods`,
            method: 'post',
            data
        })
    },
    // 视频播放
    getVideoPlayURL(id) {
        return API({ url: `/short_video/v1/video/getVideoPlayURL?videoId=${id}`, method: 'get' })
    },
})